import { render, staticRenderFns } from "./RecordOrderDetail.vue?vue&type=template&id=1277d0ca"
import script from "./RecordOrderDetail.vue?vue&type=script&lang=js"
export * from "./RecordOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordOrderDetail.vue?vue&type=style&index=0&id=1277d0ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports